/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {Subscription} from 'rxjs';

import template from './cdn-stats.component.html';
import {StatsApiService} from './stats-api.service';
import {AdnLogService} from '../../../components/util/adn-log.service';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {BrowserLocationService} from '../../angular-platform-providers';

@Component({
  standalone: false,
  selector: 'adn-cdn-stats-component',
  template
})
export class CdnStatsComponent implements OnInit, OnDestroy {
  @Input() model: any;
  @Input() param: string;

  showCdnDelivery = false;
  cdnScope: any = null;

  private readonly pricePerG = 0.003333333;
  private statsSubscription?: Subscription;

  constructor(
    private readonly statsApi: StatsApiService,
    private readonly ngZone: NgZone,
    private readonly adnLog: AdnLogService,
    @Inject(BrowserLocationService) private readonly location: any,
    @Inject(LocalUserProfile) private readonly localUserProfile: any
  ) {
  }

  ngOnInit(): void {
    this.showCdnDelivery = this.location.hostname === 'localhost'
      || this.localUserProfile.get('username') === 'adnuntius@adnuntius.com';
  }

  ngOnDestroy(): void {
    this.statsSubscription?.unsubscribe();
  }

  getCdnStats(): void {
    if (!this.model?.id || !this.param) {
      return;
    }

    const statsParams: Record<string, any> = {
      groupBy: 'MONTHLY'
    };
    statsParams[this.param] = [this.model.id];

    this.cdnScope = {
      engaged: true
    };

    this.statsSubscription?.unsubscribe();
    this.statsSubscription = this.statsApi.getCdn(statsParams).subscribe({next: (stats) => {
      this.ngZone.run(() => {
        const bytes = _.get(stats, ['totals', 'bytes']);
        const gigs = this.toGigs(bytes);
        this.cdnScope.showTeras = gigs >= 15;
        this.cdnScope.totalMegs = this.toGigs(bytes, 2);
        this.cdnScope.totalGigs = this.toGigs(bytes);
        this.cdnScope.totalTeras = this.toGigs(bytes, 4);
        this.cdnScope.error = false;
        this.cdnScope.price = this.pricePerG * this.cdnScope.totalGigs;
        this.cdnScope.haveStats = true;
        this.cdnScope.isPending = false;
      });
    }, error: (data) => {
      this.ngZone.run(() => {
        this.adnLog.warn(data);
        if (data.status !== -1) {
          this.cdnScope.error = true;
        }
        this.cdnScope.isPending = false;
      });
    }});
  }

  private toGigs(num: number, pDivisors?: number): number {
    const divisor = Math.pow(1024, (pDivisors || 3));
    return num ? (num / divisor) : 0;
  }
}
